import React from "react";
import { Box } from "@mui/material";
import { colors, fonts } from "../../theme/tokens";

const BlogsHero = () => {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        overflow: "hidden",
        pt: { xs: "60px", md: "80px" },
        pb: "50px",
        px: { xs: "20px", md: "28px" },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "-120px",
          left: "-100px",
          width: "460px",
          height: "460px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle,rgba(246,166,35,.14),transparent 65%)",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "relative",
          maxWidth: "920px",
          mx: "auto",
          textAlign: "center",
        }}
      >
        <Box sx={{ display: "inline-flex", alignItems: "center", gap: "12px" }}>
          <Box
            sx={{ width: "26px", height: "2px", background: colors.amber }}
          />
          <Box
            sx={{
              fontFamily: fonts.display,
              fontSize: "12.5px",
              fontWeight: 600,
              letterSpacing: ".2em",
              color: colors.steelBlue,
            }}
          >
            NEWS & INSIGHTS
          </Box>
          <Box
            sx={{ width: "26px", height: "2px", background: colors.amber }}
          />
        </Box>
        <Box
          component="h1"
          sx={{
            fontFamily: fonts.display,
            fontWeight: 700,
            fontSize: "clamp(32px,4.6vw,56px)",
            lineHeight: 1.05,
            letterSpacing: "-.02em",
            color: colors.navyInk,
            mt: "22px",
            mb: 0,
          }}
        >
          Insights to keep you ahead
        </Box>
        <Box
          sx={{
            fontFamily: fonts.body,
            fontSize: "18px",
            lineHeight: 1.65,
            color: colors.mutedText,
            maxWidth: "660px",
            mx: "auto",
            mt: "24px",
          }}
        >
          The latest analysis, perspectives, and practical advice from our team
          across strategy, finance, advisory, risk, audit, technology, and
          property.
        </Box>
      </Box>
    </Box>
  );
};

export default BlogsHero;
